<template lang='pug'>
  v-flex(:class="classObj", :title='label')
    div.container(style="position: relative")
      template(v-if="component.chart === undefined || component.chart")
        u-line-chart(v-model="data.percentil", :label="!print ? label : ''" :title="data.percentil !== undefined ? Math.round(data.percentil * 100) + ' %' : data.result")
        .text {{ component.prefix }} {{ resultText }} {{ component.suffix }} {{ component.showPercentil ? ` (percentil ${resultPercentil})` : '' }}
      v-text-field(v-else, :value="resultText", :title='label', :type='component.inputType || "text"', :placeholder='component.placeholder', :required='component.required', :disabled='component.disabled', :label='label' :suffix='component.suffix', :prefix='component.prefix || " "', :mask='component.mask', :min='component.min', :max='component.max', :step='component.step', hide-details)
      v-menu(v-if="!readonly && component.formulas", open-on-hover, :close-on-content-click='false', :nudge-width='200', offset-y='')
        template(v-slot:activator='{ on }')
          v-icon.btn-author-info(color="grey" small v-on='on' tabIndex="-1") fas fa-calendar-alt
        v-card
          v-card-title
            div(v-if="component.formulas && component.formulas.default === 'fieldsAvgValidate'")
              span Medidas
                v-checkbox(v-model="data.fields", v-for="param in Object.keys(component.formulas.authors.fieldsAvgValidate.params)", :label="param", :value="param", :key="param", hide-details)
            div(v-else)
              span Autores
              v-radio-group(v-model="component.formulas.default", @change="changeAuthor", hide-details)
                v-radio(v-for="key in Object.keys(component.formulas.authors)", :label="component.formulas.authors[key].title || key | capitalize", :value="key", :key="key" )
          v-card-actions(v-if="component.validate")
            v-btn(flat color="primary", @click="confirmDialog") Validar IG
      field-info(v-if="false" :field="id" :component="component" :resultForm="resultForm")
</template>

<script>
import moment from 'moment'
import ULineChart from '../../charts/LineChart'
import FieldInfo from '../buttons/FieldInfo'
import formCustomFormulas from '../../../api/formCustomFormulas'

export default {
  name: 'u-chart-line',

  components: {
    ULineChart,
    FieldInfo
  },

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: false
    },
    value: {},
    chartData: {},
    resultForm: {},
    readonly: {
      type: Boolean
    },
    print: {
      type: Boolean
    }
  },

  computed: {
    resultText () {
      return this.f(this.data.result, this.component.filter || 'weeksAndDays')
    },
    label () {
      return this.t(this.id + '.label', this.component.label)
    },
    resultPercentil () {
      let percentil = Math.round(this.data.percentil * 100)
      if (percentil > 99) return '>99%'
      return percentil < 1 ? '<1%' : percentil
    }
  },

  watch: {
    chartData: {
      handler: function (val) {
        this.update(val)
      },
      deep: true
    },
    value (val) {
      if (val && typeof val === 'object') this.data = val
    },
    data: {
      handler: function (val) {
        // FIX: FirebaseError: Function DocumentReference.update() called with invalid data.
        // Unsupported field value: undefined (found in field forms.`morphological.biometria.fetos.feto_1.igDbp`.result)
        if (val && val.result === undefined) val.result = null
        if (Math.round(this.resultForm['gestationalAge.info.calculada']) === Math.round(val.result)) {
          this.data.percentil = 0.5
        }
        this.onChange(val)
        if (val && val.fields) {
          this.triggerFieldsCalcs(val)
        }
      },
      deep: true
    }
  },

  data () {
    return {
      data: {
        result: null,
        percentil: null,
        author: null,
        fields: null
      }
    }
  },

  mounted () {
    this.update(this.chartData)
    // Inicializa o fields
    if (this.component.formulas && this.component.formulas.default === 'fieldsAvgValidate' && this.data && !this.data.fields) this.data.fields = []
  },

  methods: {
    update (payload) {
      if (payload && typeof payload === 'object') {
        this.data.result = payload.result
        if (Math.round(this.resultForm['gestationalAge.info.calculada']) === Math.round(payload.result)) {
          this.data.percentil = 0.5
        } else {
          this.data.percentil = payload.percentil
        }
        if (payload.author) {
          // this.author = payload.author
          if (this.data === null) this.data = {}
          this.data.author = payload.author
        }
      } else {
        this.data.result = payload
      }
    },
    confirmDialog () {
      let confirmed = confirm('Deseja alterar a Idade Gestacional Base?')
      if (confirmed) {
        let ageDays = Math.round(this.data.result)
        let weeks = parseInt(ageDays / 7)
        let days = Math.round(ageDays % 7)
        this.resultForm['gestationalAge.info.date'] = moment(this.resultForm['gestationalAge.info.interationDate']).subtract(this.data.result, 'days').toDate()
        this.resultForm['gestationalAge.info.calculada'] = parseInt(ageDays)
        this.resultForm['gestationalAge.info.weeks'] = weeks
        this.resultForm['gestationalAge.info.days'] = days
        this.resultForm['gestationalAge.info.calculo'] = 'manual' // this.component.label
        this.resultForm['gestationalAge.info.calculoRef'] = this.component.formulas.default === 'fieldsAvgValidate' ? this.data.fields.join(', ') : this.component.label
      }
    },
    changeAuthor () {
      // let params = this.component.formulas.authors[this.component.formulas.default].params
      // let triggerKey = params[Object.keys(params)[0]]
      this.data.author = this.component.formulas.default
      this.onChange(this.data)
    },
    async triggerFieldsCalcs (val) {
      if (!this.resultForm) return
      let params = {}
      const formulaParams = this.component.formulas.authors.fieldsAvgValidate.params
      if (!this.id) return
      let m = this.id.match(/_(\d)/)
      if (m) {
        let itemNo = m[1]
        for (let paramId in formulaParams) {
          const paramKey = formulaParams[paramId].replace(/\$/, `_${itemNo}`)
          let value = this.resultForm[paramKey]
          if (value && typeof value === 'object') {
            value = value.result
          }
          params[paramId] = value
        }
        const avgValidate = await formCustomFormulas.fieldsAvgValidate(this.id, params, {forms: this.resultForm})
        const result = avgValidate.forms[this.id].result
        if (result) {
          this.data.result = result
        } else {
          this.data.result = null
        }
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .container
    padding-top 0px!important
    position relative
    margin-top -14px
    height 50px

  .text
    font-size 14px
    font-weight normal
    text-align center
    position absolute
    left 0
    right 0
    bottom 6px

  .btn-author-info
    position absolute
    margin 0
    top 0
    right 0

  @media print
    .container, .text
      position static
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/ChartLine.vue